(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['skins.viewer.mediaControlFullscreenDefaultSkin'] = {
  "react": [
    [
      "div",
      "fullscreenButton",
      [
        "_fullscreen-button"
      ],
      {},
      [
        "div",
        "icon",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "icon": {
      "skin": "skins.viewer.VectorImageSkin"
    }
  },
  "css": {
    "%_fullscreen-button": "width:100%;height:100%;cursor:pointer;position:relative;",
    "%_fullscreen-button > div": "width:100%;height:100%;"
  }
}
 skins['skins.viewer.mediaControlPlayDefaultSkin'] = {
  "react": [
    [
      "div",
      "playButton",
      [
        "_play-button"
      ],
      {},
      [
        "div",
        "icon",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "icon": {
      "skin": "skins.viewer.VectorImageSkin"
    }
  },
  "css": {
    "%_play-button": "width:100%;height:100%;cursor:pointer;position:relative;",
    "%_play-button > div": "width:100%;height:100%;"
  }
}
 skins['skins.viewer.mediaControlProgressDefaultSkin'] = {
  "react": [
    [
      "div",
      "progressBar",
      [],
      {},
      [
        "div",
        null,
        [
          "_progress-indicator"
        ],
        {},
        [
          "div",
          "progressIdle",
          [
            "_progress-part",
            "_progress-background"
          ],
          {}
        ],
        [
          "div",
          "progressLoad",
          [
            "_progress-part",
            "_progress-load"
          ],
          {}
        ],
        [
          "div",
          "progressPlay",
          [
            "_progress-part",
            "_progress-play"
          ],
          {}
        ],
        [
          "div",
          "playhead",
          [
            "_progress-part",
            "_play-head"
          ],
          {},
          [
            "div",
            "playheadIcon",
            [],
            {}
          ]
        ],
        [
          "div",
          "playheadGhost",
          [
            "_progress-part",
            "_play-head-ghost"
          ],
          {},
          [
            "div",
            "playheadGhostIcon",
            [],
            {}
          ]
        ],
        [
          "div",
          "progressDragArea",
          [
            "_progress-part",
            "_progress-drag-area"
          ],
          {}
        ]
      ],
      [
        "div",
        "storyboard",
        [],
        {}
      ]
    ]
  ],
  "exports": {
    "playheadIcon": {
      "skin": "skins.viewer.VectorImageSkin"
    },
    "playheadGhostIcon": {
      "skin": "skins.viewer.VectorImageSkin"
    },
    "storyboard": {
      "skin": "skins.viewer.mediaControlStoryboardDefaultSkin"
    },
    "storyboardMinimal": {
      "skin": "skins.viewer.mediaControlStoryboardMinimalSkin"
    }
  },
  "params": {
    "maincolor": "COLOR",
    "buffercolor": "COLOR",
    "progresscolor": "COLOR"
  },
  "paramsDefaults": {
    "maincolor": "#fff",
    "buffercolor": "#f80",
    "progresscolor": "#f00"
  },
  "css": {
    "%progressBar": "height:100%;position:relative;",
    "%progressBar [hidden]": "display:none;",
    "%progressBar %_progress-indicator": "top:50%;width:100%;position:relative;",
    "%progressBar %_progress-part": "height:2px;margin-top:-1px;position:absolute;left:0;",
    "%progressBar %_progress-background": "width:100%;background:[maincolor];border-radius:1px;box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.3);",
    "%progressBar %_progress-load": "width:0;background:[buffercolor];border-radius:1px;",
    "%progressBar %_progress-play": "width:0;background:[progresscolor];border-radius:1px;",
    "%progressBar %_play-head,%progressBar %_play-head-ghost": "pointer-events:none;height:16px;width:16px;margin:-8px 0 0 -8px;left:0;",
    "%progressBar %_play-head > div,%progressBar %_play-head-ghost > div": "width:100%;height:100%;",
    "%progressBar %_progress-drag-area": "width:100%;height:24px;margin-top:-12px;cursor:pointer;"
  }
}
 skins['skins.viewer.mediaControlsDarkSkin'] = {
  "react": [
    [
      "div",
      "controls",
      [
        "_controls"
      ],
      {},
      [
        "div",
        "play",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "time",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "progress",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "volume",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "fullscreen",
        [
          "_control"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "play": {
      "skin": "skins.viewer.mediaControlPlayDefaultSkin"
    },
    "volume": {
      "skin": "skins.viewer.mediaControlVolumeDefaultSkin"
    },
    "fullscreen": {
      "skin": "skins.viewer.mediaControlFullscreenDefaultSkin"
    },
    "progress": {
      "skin": "skins.viewer.mediaControlProgressDefaultSkin"
    },
    "time": {
      "skin": "skins.viewer.mediaControlTimeDefaultSkin"
    }
  },
  "css": {
    "%_controls": "width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;align-items:center;",
    "%_controls %_control:first-child": "margin-left:21px;",
    "%_controls %_control:last-child": "margin-right:20px;",
    "%_controls %play": "width:24px;min-width:24px;margin-right:14px;",
    "%_controls %time": "width:auto;margin-right:25px;",
    "%_controls %progress": "min-width:105px;-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1;margin-right:19px;",
    "%_controls %volume": "width:31px;min-width:31px;margin-right:10px;",
    "%_controls%_has-audio %volume": "width:81px;min-width:50px;margin-right:20px;",
    "%_controls %fullscreen": "width:24px;min-width:24px;",
    "%[data-element-query-width~=\"small\"] %_controls %_control:first-child": "margin-left:13px;",
    "%[data-element-query-width~=\"small\"] %_controls %_control:last-child": "margin-right:12px;",
    "%[data-element-query-width~=\"small\"] %_controls %time": "display:none;",
    "%[data-element-query-width~=\"minimal\"] %_controls%_has-audio %volume": "width:31px;min-width:31px;margin-right:10px;"
  }
}
 skins['skins.viewer.mediaControlsLightSkin'] = {
  "react": [
    [
      "div",
      "controls",
      [
        "_controls"
      ],
      {},
      [
        "div",
        "play",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "time",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "progress",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "volume",
        [
          "_control"
        ],
        {}
      ],
      [
        "div",
        "fullscreen",
        [
          "_control"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "play": {
      "skin": "skins.viewer.mediaControlPlayDefaultSkin"
    },
    "volume": {
      "skin": "skins.viewer.mediaControlVolumeDefaultSkin"
    },
    "fullscreen": {
      "skin": "skins.viewer.mediaControlFullscreenDefaultSkin"
    },
    "progress": {
      "skin": "skins.viewer.mediaControlProgressDefaultSkin"
    },
    "time": {
      "skin": "skins.viewer.mediaControlTimeDefaultSkin"
    }
  },
  "css": {
    "%_controls": "width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;align-items:center;",
    "%_controls %_control:first-child": "margin-left:21px;",
    "%_controls %_control:last-child": "margin-right:20px;",
    "%_controls %play": "width:24px;min-width:24px;margin-right:14px;",
    "%_controls %time": "width:auto;margin-right:25px;",
    "%_controls %progress": "min-width:105px;-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1;margin-right:19px;",
    "%_controls %volume": "width:31px;min-width:31px;margin-right:10px;",
    "%_controls%_has-audio %volume": "width:81px;min-width:50px;margin-right:20px;",
    "%_controls %fullscreen": "width:24px;min-width:24px;",
    "%[data-element-query-width~=\"small\"] %_controls %_control:first-child": "margin-left:13px;",
    "%[data-element-query-width~=\"small\"] %_controls %_control:last-child": "margin-right:12px;",
    "%[data-element-query-width~=\"small\"] %_controls %time": "display:none;",
    "%[data-element-query-width~=\"minimal\"] %_controls%_has-audio %volume": "width:31px;min-width:31px;margin-right:10px;"
  }
}
 skins['skins.viewer.mediaControlsNoControlsSkin'] = {
  "react": [
    [
      "div",
      "controls",
      [
        "_controls"
      ],
      {},
      [
        "div",
        "volume",
        [
          "_control"
        ],
        {}
      ]
    ]
  ],
  "exports": {
    "volume": {
      "skin": "skins.viewer.mediaControlVolumeDefaultSkin"
    }
  },
  "css": {
    "%": "pointer-events:none;",
    "%_controls": "margin:0 10px 0 auto;width:31px;height:100%;",
    "%_controls %_control": "pointer-events:auto;",
    "%_controls %volume": "width:31px;min-width:31px;"
  }
}
 skins['skins.viewer.mediaControlStoryboardDefaultSkin'] = {
  "react": [
    [
      "div",
      null,
      [
        "_video-storyboard"
      ],
      {},
      [
        "video",
        "video",
        [
          "_media-preview"
        ],
        {
          "muted": "",
          "preload": "auto"
        },
        [
          "source",
          "mediaSource",
          [],
          {
            "type": "video/mp4"
          }
        ]
      ],
      [
        "div",
        "label",
        [
          "_media-preview-caption"
        ],
        {}
      ]
    ]
  ],
  "params": {
    "maincolor": "COLOR"
  },
  "paramsDefaults": {
    "maincolor": "color_11"
  },
  "css": {
    "%": "position:absolute;pointer-events:none;",
    "%_video-storyboard": "margin-left:-50%;width:100%;height:100%;background-color:rgba(30, 30, 30, 0.9);box-sizing:border-box;border-radius:2px;overflow:hidden;padding:2px;",
    "%_media-preview": "width:100%;height:100%;box-sizing:border-box;margin:0;padding:0;",
    "%label": "position:absolute;bottom:5px;width:100%;text-align:center;padding:0;color:[maincolor];font-size:12px;text-shadow:0 1px 4px rgba(0, 0, 0, 0.2);"
  }
}
 skins['skins.viewer.mediaControlStoryboardMinimalSkin'] = {
  "react": [
    [
      "div",
      "backgroundSymbol",
      [],
      {},
      [
        "div",
        "icon",
        [],
        {}
      ]
    ],
    [
      "div",
      "label",
      [
        "_media-preview-caption"
      ],
      {}
    ]
  ],
  "exports": {
    "icon": {
      "skin": "skins.viewer.VectorImageSkin"
    }
  },
  "params": {
    "textcolor": "COLOR"
  },
  "paramsDefaults": {
    "textcolor": "color_15"
  },
  "css": {
    "%": "position:absolute;top:-10px;",
    "%backgroundSymbol": "width:41px;height:20px;position:relative;",
    "%backgroundSymbol > div": "width:100%;height:100%;",
    "%label": "position:absolute;top:0;left:0;height:20px;line-height:20px;width:100%;text-align:center;color:[textcolor];font-size:12px;"
  }
}
 skins['skins.viewer.mediaControlTimeDefaultSkin'] = {
  "react": [
    [
      "div",
      "timeIndicator",
      [],
      {},
      [
        "span",
        "played",
        [
          "_time-played"
        ],
        {}
      ],
      [
        "span",
        null,
        [
          "_divider"
        ],
        {
          "aria-hidden": true
        }
      ],
      [
        "span",
        "total",
        [
          "_total-time"
        ],
        {}
      ]
    ]
  ],
  "params": {
    "maincolor": "COLOR"
  },
  "paramsDefaults": {
    "maincolor": "color_11"
  },
  "css": {
    "%timeIndicator": "display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;width:100%;height:100%;font-size:12px;line-height:12px;color:[maincolor];text-shadow:0 1px 3px rgba(0, 0, 0, 0.4);",
    "%timeIndicator %_divider::after": "content:'\\00a0/\\00a0';"
  }
}
 skins['skins.viewer.mediaControlVolumeDefaultSkin'] = {
  "react": [
    [
      "div",
      "volume",
      [],
      {},
      [
        "div",
        "mute",
        [
          "_volume-mute"
        ],
        {},
        [
          "div",
          "icon",
          [],
          {}
        ]
      ],
      [
        "div",
        "volumeBar",
        [
          "_volume-control",
          "_volume-bar"
        ],
        {},
        [
          "div",
          "volumeBarIdle",
          [
            "_volume-bar-part",
            "_volume-bar-idle"
          ],
          {}
        ],
        [
          "div",
          "volumeBarActive",
          [
            "_volume-bar-part",
            "_volume-bar-active"
          ],
          {}
        ],
        [
          "div",
          "volumeBarDragArea",
          [
            "_volume-bar-part",
            "_volume-bar-drag-area"
          ],
          {}
        ]
      ]
    ]
  ],
  "exports": {
    "icon": {
      "skin": "skins.viewer.VectorImageSkin"
    }
  },
  "params": {
    "maincolor": "COLOR",
    "progresscolor": "COLOR",
    "disabledcolor": "COLOR"
  },
  "paramsDefaults": {
    "maincolor": "#fff",
    "progresscolor": "#1fdf67",
    "disabledcolor": "#777"
  },
  "css": {
    "%volume": "width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;",
    "%volume %_volume-mute": "height:100%;width:31px;margin-right:2px;cursor:pointer;position:relative;",
    "%volume %_volume-mute > div": "width:100%;height:100%;",
    "%volume %_volume-bar": "-webkit-box-flex:1;-webkit-flex-grow:1;flex-grow:1;position:relative;",
    "%volume %_volume-bar %_volume-bar-part": "top:50%;width:100%;height:2px;margin-top:-1px;position:absolute;left:0;",
    "%volume %_volume-bar %_volume-bar-idle": "background:[maincolor];border-radius:1px;box-shadow:0 1px 3px 0 rgba(0, 0, 0, 0.3);",
    "%volume %_volume-bar %_volume-bar-active": "pointer-events:none;width:0;background:[progresscolor];border-radius:1px;",
    "%volume %_volume-bar %_volume-bar-drag-area": "height:24px;margin-top:-12px;cursor:pointer;",
    "%volume%_muted %_volume-bar-drag-area": "cursor:default;",
    "%volume%_muted %_volume-bar-active": "background:[disabledcolor];",
    "%volume%_disabled %_volume-mute": "cursor:default;"
  }
}
 skins['skins.viewer.mediaOverlayControlsDefaultSkin'] = {
  "react": [
    [
      "div",
      "indicator",
      [],
      {}
    ],
    [
      "div",
      "catcher",
      [],
      {}
    ]
  ],
  "exports": {
    "indicator": {
      "skin": "skins.viewer.VectorImageSkin"
    }
  },
  "css": {
    "%catcher": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "%_indicator": "position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;",
    "%_interactive-player": "cursor:pointer;"
  }
}

        return skins;
    }));